// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "\\e931";
  font-family: "condominioapp";
}`, "",{"version":3,"sources":["webpack://./src/app/core/shared/components/modais/responder-suportes/responder-suportes.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,4BAAA;AACF","sourcesContent":[".custom-file-input:lang(en) ~ .custom-file-label::after {\n  content: \"\\e931\";\n  font-family: \"condominioapp\";\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
